import { useEffect, useState } from 'react';

/**
 * A two-route router in twenty lines.
 *
 * The app has a home page and an inspector, and nothing about that is going to
 * grow enough to earn a routing dependency. The API already serves `index.html`
 * for any unmatched GET, so real URLs work on reload and share.
 */

const NAVIGATION_EVENT = 'mockapi:navigate';

export function navigate(to: string): void {
  if (to === window.location.pathname) return;
  window.history.pushState(null, '', to);
  window.dispatchEvent(new Event(NAVIGATION_EVENT));
}

export function usePathname(): string {
  const [pathname, setPathname] = useState(() => window.location.pathname);

  useEffect(() => {
    const sync = (): void => setPathname(window.location.pathname);

    // `popstate` covers back/forward; the custom event covers our own pushes,
    // which do not fire it.
    window.addEventListener('popstate', sync);
    window.addEventListener(NAVIGATION_EVENT, sync);

    return () => {
      window.removeEventListener('popstate', sync);
      window.removeEventListener(NAVIGATION_EVENT, sync);
    };
  }, []);

  return pathname;
}

export function inspectorPath(slug: string): string {
  return `/i/${slug}`;
}

/** The slug an inspector URL points at, or `undefined` for any other path. */
export function matchInspector(pathname: string): string | undefined {
  const match = /^\/i\/([^/]+)\/?$/.exec(pathname);
  return match?.[1];
}
